import React from 'react'

interface BoxedContentProps {
  children?: React.ReactNode
}

export const BoxedContent: React.FC<BoxedContentProps> = ({ children }) => {
  return (
    <div className="flex flex-col px-4 md:px-8">
      <div className="w-full max-w-7xl self-center">{children}</div>
    </div>
  )
}
